import { create } from "zustand";

type AppUpdateState = {
  updateAvailable: boolean;
  setUpdateAvailable: (value: boolean) => void;
};

/** Written by `useAppUpdate` when it sees a new build; read by the banner. */
export const useAppUpdateStore = create<AppUpdateState>((set) => ({
  updateAvailable: false,
  setUpdateAvailable: (value) => set({ updateAvailable: value }),
}));
